import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, TextField } from '@mui/material'
import { connect } from 'react-redux'
import { setHeaderSearchHover } from '../../reducers/ThemeOptions'
import { headerSearchWrapperSx } from '@/layout-blueprints/chromeComponentSx'

const HeaderSearch = (props) => {
  const { headerSearchHover, setHeaderSearchHover } = props

  const toggleHeaderSearchHover = () => {
    setHeaderSearchHover(!headerSearchHover)
  }

  return (
    <Box sx={headerSearchWrapperSx({ open: headerSearchHover })}>
      <Box sx={{ position: 'relative', transition: 'all 0.2s ease-in-out', }} data-hf="search-field">
        <Box component="label" htmlFor="header-search-input" data-hf="search-icon">
          <FontAwesomeIcon icon={['fas', 'magnifying-glass']} />
        </Box>
        <TextField
          onFocus={toggleHeaderSearchHover}
          onBlur={toggleHeaderSearchHover}
          id="header-search-input"
          name="header-search-input"
          type="search"
          placeholder="Search terms..."
          variant="outlined"
        />
      </Box>
    </Box>
  )
}

const mapStateToProps = (state) => ({
  headerSearchHover: state.DeprecatedThemeOptions.headerSearchHover,
})

const mapDispatchToProps = (dispatch) => ({
  setHeaderSearchHover: (enable) =>
    dispatch(setHeaderSearchHover(enable)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HeaderSearch)
